(ns dashboard.views.settings.roles
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.inputs :refer [input]]
   [dashboard.components.table :refer [table]]
   ["date-fns" :refer [formatISO formatDistance]]))

(defn content []
  (let [state (reagent/atom (listen ::subs/userinfo))]
    (fn []
      [:div.divide-y.divide-gray-200
       [:div.py-6.px-4
        [table
         {:headers [{:title (tr :user/role)
                     :key :name
                     :render-cell (fn [name]
                                    [:span
                                     name])}
                    {:title (tr :role/permissions)
                     :key :permissions
                     :render-cell (fn [permissions]
                                    [:div.flex.flex-col.w-64.divide-y
                                     (doall
                                      (for [permission permissions]
                                        ^{:key (:resource permission)}
                                        [:div.py-1.flex.justify-between.text-sm.font-medium
                                         [:dt.text-gray-500.flex
                                          (when (some? (namespace (:resource permission)))
                                            [:div.text-gray-500.mr-1.capitalize
                                             (namespace (:resource permission))])
                                          [:div.capitalize
                                           (name (:resource permission))]]
                                         [:dd.text-gray-900.capitalize
                                          (str (name (:action permission)) "able")]]))])}]
          :rows (listen ::subs/roles)}]]
       #_[:div.pt-6.divide-y.divide-gray-200
        [:div.py-4.px-4.flex.justify-end.sm:px-6
         [button
          {:type "submit"}
          (tr :action/save)]]]])))
